export const PO_STATUSES = [
  { value: 'Confirmed', label: 'Confirmed', name: 'Confirmed' },
  { value: 'Arrived', label: 'Arrived', name: 'Arrived' },
  { value: 'Receiving', label: 'Receiving', name: 'Receiving' },
  { value: 'Processed', label: 'Processed', name: 'Processed' },
  ];

export const reasonOptions = [
  { value: 'Damaged Products', label: 'Damaged Products' },
  { value: 'Expired Products', label: 'Expired Products' },
  { value: 'Other', label: 'Other' },
];
  